export default "__VITE_PUBLIC_ASSET__c11db75b__"